// import vars from '../helpers';
import Plyr from 'plyr';
let player = null;

function init() {
	const videoID = document.getElementById('sectionVideo');

	player = new Plyr(videoID, {
		title: 'Video home',
		controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'],
		hideControls: false,
	});

	// Auto-rotation on mobile
	// vars.$document.on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', () => {
	// 	if (player.fullscreen.active) {
	// 		screen.orientation.lock('landscape');
	// 	} else {
	// 		screen.orientation.unlock();
	// 	}
	// });

	return player;
}

function destroy() {
	if (player) {
		player.destroy();
		player = null;
	}
}

export default {
	init,
	destroy,
};
